import { SelectCustom } from '../../../common/selectCustom'
import { SCROLL_LAYOUT_ELEMENT_ID } from '../../../layout/LayoutContainer'
import classes from '../../index.module.scss'

export const JobTitleSelection = ({
  activeJobTitle,
  setJobTitle,
  jobTitlesList,
}) => {
  return (
    !!jobTitlesList.length && (
      <div className={classes.inputForm}>
        <SelectCustom
          data={jobTitlesList}
          chooseItem={setJobTitle}
          isI18n={false}
          activeItem={activeJobTitle}
          zIndex={14}
          labelOnBorder="userProfile.JOB_TITLE"
          styleLabelOnBorder={{ backgroundColor: '#FFFFFF' }}
          scrollId={SCROLL_LAYOUT_ELEMENT_ID}
        />
      </div>
    )
  )
}
